import * as yup from 'yup';

export default {
    beforeCreate()
    {
        yup.setLocale({
            mixed: {
                required: obj => `${obj.label ? obj.label : obj.path} is verplicht`, // `${obj.path} is default`,
                oneOf: obj => `Actievoorwaarden zijn verplicht`
            },
            string: {
                min: obj => `${obj.path} moet minstens ${obj.min} karakters lang zijn`,
                matches: obj => `Dit is geen geldig ${obj.label}.`
            },
            number: {
                min: obj => `${obj.label} moet minstens ${obj.min} zijn`,
                max: obj => `${obj.label} mag maximaal ${obj.max} zijn`
            }
        });
    },

    data()
    {
        return {
            formConfig: {
                gender: [
                    {
                        id: 'gender-a',
                        label: 'De heer',
                        type: 'radio',
                        // value: 'male',
                        name: 'gender',
                        tabindex: 1
                    },
                    {
                        id: 'gender-b',
                        label: 'Mevrouw',
                        type: 'radio',
                        // value: 'female',
                        name: 'gender',
                        tabindex: 2
                    }
                ],
                firstname: {
                    // name: 'firstname',
                    label: 'Voornaam',
                    name: 'firstname',
                    type: 'text',
                    // placeholder: 'Bijv. Klaas',
                    autocomplete: 'given-name',
                    tabindex: 3
                },

                infixname: {
                    label: 'Tussenvoegsel',
                    name: 'infixname',
                    type: 'text',
                    // placeholder: 'bijv. ten',
                    autocomplete: 'infix-name',
                    tabindex: 4
                },

                surname: {
                    label: 'Achternaam',
                    name: 'surname',
                    type: 'text',
                    // placeholder: 'bv. Klaassen',
                    autocomplete: 'family-name',
                    tabindex: 5
                },

                emailaddress: {
                    label: 'E-mailadres',
                    name: 'emailaddress',
                    // placeholder: 'bijv. info@stl.nl',
                    type: 'email',
                    tabindex: 6
                },

                dayOfBirth: {
                    label: 'Dag',
                    name: 'dayOfBirth',
                    type: 'number',
                    // placeholder: 'Dag',
                    autocomplete: 'bday-day',
                    min: 1,
                    max: 31,
                    tabindex: 7
                },

                monthOfBirth: {
                    label: '',
                    name: 'monthOfBirth',
                    type: 'number',
                    // placeholder: 'Maand',
                    autocomplete: 'bday-month',
                    options: [
                        'januari',
                        'februari',
                        'maart',
                        'april',
                        'mei',
                        'juni',
                        'juli',
                        'augustus',
                        'september',
                        'oktober',
                        'november',
                        'december'
                    ],
                    tabindex: 8
                },

                yearOfBirth: {
                    label: 'Geboortejaar',
                    name: 'yearOfBirth',
                    type: 'number',
                    // placeholder: 'Jaar',
                    autocomplete: 'bday-year',
                    min: 1900,
                    max: new Date().getFullYear(),
                    tabindex: 9
                },

                zipcode: {
                    label: 'Postcode',
                    name: 'zipcode',
                    type: 'text',
                    // placeholder: 'bijv. 1234AB',
                    tabindex: 10
                },

                house_num: {
                    label: 'Huisnummer',
                    name: 'house_num',
                    type: 'number',
                    min: 0,
                    tabindex: 11
                },

                house_num_add: {
                    name: 'house_num_add',
                    label: 'Toevoeging',
                    type: 'text',
                    tabindex: 12
                },

                kit: {
                    type: 'checkbox',
                    name: 'kit',
                    id: 'kit-checkbox',
                    tabindex: 13
                },

                av: {
                    type: 'checkbox',
                    name: 'av',
                    value: 'agree',
                    id: 'av-checkbox',
                    tabindex: 14
                }
            },

            validationSchema: yup.object().shape({
                av: yup.string()
                    .label( 'actievoorwaarden' )
                    .required().oneOf( [ true, 'true', 'accept', 'agree' ] ),
                gender: yup.string()
                    .label( 'aanhef' )
                    .required(),
                firstname: yup.string()
                    .label( 'voornaam' )
                    .required()
                    /* eslint-disable-next-line */
                    .matches( /^([A-z\-\s])+$/ )
                    .min( 2 ),
                surname: yup.string()
                    .label( 'achternaam' )
                    .required()
                    /* eslint-disable-next-line */
                    .matches( /^([A-z\-\s'])+$/ )
                    .min( 2 ),
                dayOfBirth: yup.number()
                    .nullable()
                    .transform( value => ( isNaN( value ) ? undefined : value ) )
                    .label( 'dag' )
                    .required()
                    .min( 1 )
                    .max( 31 ),
                monthOfBirth: yup.number()
                    .nullable()
                    .transform( value => ( isNaN( value ) ? undefined : value ) )
                    .label( 'maand' )
                    .required()
                    .min( 0 )
                    .max( 11 ),
                yearOfBirth: yup.number()
                    .nullable()
                    .label( 'geboortejaar' )
                    .required()
                    .min( 1900 )
                    .max( 2002, 'Je moet minstens 18 jaar zijn om mee te doen' ),
                dateOfBirth: yup.date()
                    .label( 'geboortedatum' )
                    .required()
                    .test(
                        'date-of-birth',
                        'Dit is geen geldige geboortedatum',
                        value =>
                        {
                            if( isNaN( value ) ) // no real date
                            {
                                return false;
                            }

                            /* eslint-disable */
                            if( value.getDate() != this.entry.dayOfBirth ||
                                value.getMonth() != this.entry.monthOfBirth ||
                                value.getFullYear() != this.entry.yearOfBirth ) // mismatch in date input and date model
                            {
                                return false;
                            }
                            /* eslint-enable */

                            return true;
                        }
                    ),
                zipcode: yup.string()
                    .label( 'postcode' )
                    .required()
                    .matches( /^[1-9][0-9]{3}[A-Za-z]{2}$/ ),
                house_num: yup.number( 'Geen geldig huisnummer' )
                    .label( 'huisnummer' )
                    .transform( value => ( isNaN( value ) ? undefined : value ) )
                    .nullable()
                    .required()
                    .min( 1 ),
                house_num_add: yup.string()
                    .label( 'toevoeging' )
                    /* eslint-disable-next-line */
                    .matches( /^([A-z0-9\-])+$/, { excludeEmptyString: true })
                    .max( 10 ),
                emailaddress: yup.string()
                    .label( 'e-mail' )
                    .required()
                    .email( 'Dit is geen valide mailadres' )
            })
        };
    }
};
